import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);
let user = localStorage.getItem('userInfo');
const store = new Vuex.Store({
    state: {
        userInfo: user,
    },
    mutations: {
        userInfo: function (state, payload) {
            const value = JSON.stringify(payload);
            localStorage.setItem('userInfo', value);
            state.userInfo = value;
        },
        logout: function (state, payload) {
            state.userInfo = null;
            localStorage.removeItem('userInfo');
        }
    },
    getters: {
        user: (state) => {
            return JSON.parse(state.userInfo);
        },
        _token: () => {
            return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        },
    },
});
export default store;
